import e from "../../../utilities/tw.js";
const t = {
  base: e`grid grid-cols-[auto_max-content] rounded border-2 shadow-md [grid-template-areas:_'title_action'_'description_action']`,
  variant: {
    error: e`border-error bg-error-surface`,
    information: e`border-info bg-info-surface`,
    success: e`border-success bg-success-surface`,
    alert: e`border-accent bg-accent-surface`
  },
  description: e`flex overflow-auto p-4 text-base font-regular text-neutral-inverse`,
  icon: e`items-baseline`,
  descriptionImage: e`mr-3`,
  actionButton: e`inline-flex justify-center rounded text-xs font-regular`,
  closeIcon: e`size-4 align-middle text-neutral-inverse`,
  viewPort: e`z-[2147483647] m-0 flex max-w-[100vw] list-none flex-col outline-none`
};
export {
  t as default
};
